import { useContext } from 'react'

import { SubMenuContext } from '../context'

export function useSubMenu() {
  return useContext(SubMenuContext)
}
